/** Shared sizing for list-page search inputs and multi-select filters — PaceHRM DS. */

/** ModalShell uses z-[12000]; filter menus inside modals must sit above it. */
export const MODAL_FILTER_MENU_Z_INDEX = 13000;

export const FILTER_BAR_HEIGHT = "h-9";
export const FILTER_BAR_MIN_H = "min-h-9";

export const FILTER_INPUT_CLASS = [
  FILTER_BAR_HEIGHT,
  FILTER_BAR_MIN_H,
  "w-full min-w-0",
  "border border-[hsl(var(--ds-border))] rounded-xl",
  "px-3 text-sm text-[hsl(var(--ds-fg))]",
  "bg-[hsl(var(--ds-surface))] shadow-sm",
  "placeholder:text-[hsl(var(--ds-muted-fg))]",
  "hover:border-[hsl(var(--ds-primary)/0.45)]",
  "focus:outline-none focus:border-[hsl(var(--ds-primary))] focus:ring-1 focus:ring-[hsl(var(--ds-ring))]",
].join(" ");

export const FILTER_TRIGGER_CLASS = [
  FILTER_BAR_HEIGHT,
  FILTER_BAR_MIN_H,
  "w-full min-w-0",
  "appearance-none relative text-left",
  "border border-[hsl(var(--ds-border))] rounded-xl font-medium",
  "px-3 text-sm pr-14",
  "bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-fg))] shadow-sm",
  "transition-colors",
  "focus:outline-none focus:border-[hsl(var(--ds-primary))] focus:ring-1 focus:ring-[hsl(var(--ds-ring))]",
  "hover:border-[hsl(var(--ds-primary)/0.45)]",
].join(" ");

export const FILTER_CLEAR_BTN_CLASS = [
  FILTER_BAR_HEIGHT,
  "w-9 shrink-0",
  "flex items-center justify-center",
  "border border-[hsl(var(--ds-border))] rounded-xl",
  "bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-muted-fg))] hover:text-[hsl(var(--ds-fg))] hover:border-[hsl(var(--ds-primary)/0.45)]",
].join(" ");
